import * as React from "react"
import { Search, X } from "lucide-react"

import { Input } from "@/components/ui/input"

interface SearchBarProps {
  value: string
  onChange: (value: string) => void
}

export function SearchBar({ value, onChange }: SearchBarProps) {
  const [local, setLocal] = React.useState(value)
  const [prevValue, setPrevValue] = React.useState(value)

  if (value !== prevValue) {
    setPrevValue(value)
    setLocal(value)
  }

  React.useEffect(() => {
    const timer = setTimeout(() => {
      if (local !== value) {
        onChange(local)
      }
    }, 150)
    return () => clearTimeout(timer)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [local])

  return (
    <div className="relative w-full">
      <Search className="pointer-events-none absolute top-1/2 left-3 size-4 -translate-y-1/2 text-muted-foreground" />
      <Input
        value={local}
        onChange={(e) => setLocal(e.target.value)}
        placeholder="곡 제목, 아티스트, 초성으로 검색 (예: ㅂㅃㄱㅅㅊㄱ)"
        className="h-11 pr-9 pl-9"
        aria-label="곡 검색"
      />
      {local && (
        <button
          type="button"
          onClick={() => setLocal("")}
          aria-label="검색어 지우기"
          className="absolute top-1/2 right-3 -translate-y-1/2 text-muted-foreground hover:text-foreground"
        >
          <X className="size-4" />
        </button>
      )}
    </div>
  )
}
